module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "content-chapter3",
    attrs: {
      "id": "calibre_toc_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/5Ingredient_split_006#_idTextAnchor023"
    }
  }, [_vm._v("Breakfast All Day"), _c('span', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Mini Meatball Breakfast Hash")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Quinoa Breakfast Bowl")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Keto Trucker’s Breakfast")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Crispy Crepes Benedict")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Post-Workout Protein Smoothie")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("No-Bake Granola")]), _vm._v(" "), _c('p', {
    staticClass: "recipes-chapters_recipes-chapter-recipes-pages"
  }, [_vm._v("Breakfast Tacos")]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_52"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3346b22a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_030.vue
// module id = 147
// module chunks = 0